import { createReducer, on } from '@ngrx/store';
import { userInitialState, UserState } from '@store/states/user.state';
import { userActions } from '@store/actions/user.actions';

export const userReducer = createReducer(
  userInitialState,
  on(userActions.setUser, userActions.updateUser, (state, { user }): UserState => {
    return {
      ...state,
      user,
      error: null,
      waitingForCountry: false,
    };
  }),
  on(userActions.fetchUser, (state): UserState => {
    return {
      ...state,
      waitingForCountry: true,
    };
  }),
  on(
    userActions.setError,
    (state, { error }): UserState => ({
      ...state,
      error,
      user: null,
    })
  ),
  on(
    userActions.setImpersonation,
    (state, { impersonationToken }): UserState => ({
      ...state,
      impersonationToken,
    })
  ),
  on(
    userActions.setCountry,
    (state, { user, multi }): UserState => ({
      ...state,
      multipleCountries: multi ?? null,
      country: user.country,
    })
  ),
  on(userActions.showDataProtectionDialog, (state): UserState => ({ ...state, waitingForDataProtection: true })),
  on(userActions.dataProtectionAccepted, (state): UserState => ({ ...state, waitingForDataProtection: false })),
  on(
    userActions.markWebAsReady,
    (state): UserState => ({
      ...state,
      waitingForCountry: false,
      waitingForDataProtection: false,
    })
  ),
  on(
    userActions.setEnergyRehabilitationMode,
    (state, { enabled }): UserState => ({
      ...state,
      isEnergyRehabilitationMode: enabled,
    })
  )
);
